<template>
  <v-col cols="12" v-if="permisoVista('disponibilidad','r')">
    <v-row>
      <v-col cols="3">
        <v-autocomplete
          v-model="turno"
          :items="turnos"
          item-text="nombre"
          item-value="idTurno"
          label="Turno"
          return-object
          clearable
          @click:clear="resetTurno"
          @change="getDatos"
        />
      </v-col>
      <v-col cols="3">
        <v-autocomplete
          v-model="idsPersonasExcluir"
          :items="personasTurno"
          :item-text="nombrePersona"
          item-value="idPersona"
          multiple
          :label="personaExcluir"
          clearable
          @click:clear="resetExcluir"
          @change="getDatos"
        />
      </v-col>
      <v-col cols="3">
        <v-autocomplete
          v-model="idsPersonasIncluir"
          :items="personasOtrosTurnos"
          :item-text="nombrePersona"
          item-value="idPersona"
          multiple
          clearable
          label="Incluir Personas"
          @click:clear="resetIncluir"
          @change="getDatos"
        />
      </v-col>
      <v-col cols="3">
        <v-autocomplete
          v-model="idsMaquinasExcluir"
          :items="maquinasIns"
          :item-text="nombreMaquina"
          item-value="idMaquinaIns"
          multiple
          label="Excluir Máquinas"
          clearable
          @click:clear="resetExcluirMaquinas"
          @change="getDatos"
        />
      </v-col>
    </v-row>

    <v-row class="mb-2">
      <v-col cols="12" class="text-right">
        <v-btn
          color="primary"
          :disabled="loading || !tieneCambios"
          :loading="saving"
          @click="guardarCambios"
        >
          Guardar Cambios
        </v-btn>
      </v-col>
    </v-row>

    <v-data-table
      :items="datosOrdenados"
      :headers="headers"
      :item-key="'idFila'"
      :loading="loading"
      :items-per-page="-1"
      hide-default-footer
      disable-sort
    >
      <template v-slot:item.importanciaMaquina="{ item }">
        <div class="d-flex align-center">
          <v-rating
            :key="`rating-${item.idFila}-${item.importanciaMaquina}`"
            dense
            hover
            clearable
            color="amber"
            background-color="amber"
            length="5"
            :value="toStars(item.importanciaMaquina)"
            @input="actualizarImportancia(item, $event)"
          />
          <v-btn x-small icon class="ml-1" title="Poner en 0%" @click.stop="actualizarImportancia(item, 0)">
            <v-icon small color="grey darken-1">mdi-star-off</v-icon>
          </v-btn>
          <span class="ml-2 caption">{{ Number(item.importanciaMaquina) || 0 }}%</span>
        </div>
      </template>

      <template v-slot:item.maquina="{ item }">
        <span>{{ item.nombre || nombreMaquinaById(item.idMaquinaIns) }}</span>
      </template>

      <template v-slot:item.molde="{ item }">
        <span>{{ nombreMoldeActual(item) }}</span>
      </template>

      <template v-slot:item.personas="{ item }">
        <v-autocomplete
          v-model="item.idsPersonasVinculadas"
          :items="personasDisponiblesPorItem(item)"
          :item-text="nombrePersona"
          item-value="idOperador"
          chips
          deletable-chips
          multiple
          clearable
          hide-details
          dense
          label="Vincular personas"
          @change="marcarCambioPersonas(item)"
        />
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
import axios from "axios";

const EP_DISPONIBILIDAD = "/Disponibilidad/DisponibilidadMaquinas";
const EP_GUARDAR_IMPORTANCIA = "/Disponibilidad/ImportanciaMaquinas";
const EP_GUARDAR_VINCULOS = "/Disponibilidad/AsignacionPersonasMaquinas";

export default {
  data() {
    return {
      turnos: [],
      personas: [],
      maquinasIns: [],
      moldes: [],
      turno: null,
      idsPersonasExcluir: [],
      idsPersonasIncluir: [],
      idsMaquinasExcluir: [],
      loading: false,
      saving: false,
      datos: [],
      dirtyImportancia: {},
      dirtyPersonas: {},
      headers: [
        { text: "Importancia", align: "center", value: "importanciaMaquina", width: "16%" },
        { text: "Maquina", align: "center", value: "maquina", width: "29%" },
        { text: "Molde actual", align: "center", value: "molde", width: "20%" },
        { text: "Personas enlazadas", align: "center", value: "personas", width: "35%" },
      ],
    };
  },
  mounted() {
    this.initialize();
  },
  computed: {
    personasTurno() {
      if (!this.$utils.isValid(this.turno)) return [];
      return this.personas.filter((p) => p.idTurno == this.turno.idTurno);
    },
    personaExcluir() {
      if (!this.$utils.isValid(this.turno)) return "Excluir";
      return `Excluir - ${this.turno.nombre}`;
    },
    personasOtrosTurnos() {
      if (!this.$utils.isValid(this.turno)) return [];
      const idsTurnos = this.$utils.arrays.unique(
        this.personas.filter((p) => p.idTurno != this.turno.idTurno).map((p) => p.idTurno)
      );
      let agrupadas = [];
      let primero = true;
      idsTurnos.forEach((idTurno) => {
        const posTurno = this.turnos.findIndex((t) => t.idTurno == idTurno);
        if (posTurno < 0) return;
        if (!primero) agrupadas.push({ divider: true });
        else primero = false;
        agrupadas.push({ header: this.turnos[posTurno].nombre });
        agrupadas = agrupadas.concat(
          this.personas.filter((p) => p.idTurno == idTurno).map((p) => ({
            idPersona: p.idPersona,
            nombre: p.nombre,
            paterno: p.paterno,
            materno: p.materno,
            group: this.turnos[posTurno].nombre,
          }))
        );
      });
      return agrupadas;
    },
    personasFiltradas() {
      if (!this.$utils.isValid(this.turno)) return this.personas;
      const excluir = new Set(this.idsPersonasExcluir || []);
      const incluir = new Set(this.idsPersonasIncluir || []);
      return this.personas.filter((p) => {
        if (incluir.has(p.idPersona)) return true;
        return p.idTurno == this.turno.idTurno && !excluir.has(p.idPersona);
      });
    },
    personasById() {
      const map = new Map();
      (this.personas || []).forEach((p) => {
        const idOperador = this.getIdOperador(p);
        const idPersona = Number(p && p.idPersona);
        if (Number.isFinite(idOperador) && idOperador > 0) map.set(idOperador, p);
        if (Number.isFinite(idPersona) && idPersona > 0) map.set(idPersona, p);
      });
      return map;
    },
    datosOrdenados() {
      return [...(this.datos || [])].sort(
        (a, b) => (Number(b.importanciaMaquina) || 0) - (Number(a.importanciaMaquina) || 0)
      );
    },
    tieneCambios() {
      return Object.keys(this.dirtyImportancia).length > 0 || Object.keys(this.dirtyPersonas).length > 0;
    },
    realizarPeticion() {
      return this.$utils.isValid(this.turno) && !this.loading;
    },
    urlDatos() {
      let url = EP_DISPONIBILIDAD;
      if (this.$utils.isValid(this.turno)) url += `?IdTurno=${this.turno.idTurno}`;
      else url += "?IdTurno=0";
      this.idsPersonasExcluir.forEach((idPersona) => {
        url += `&IdsPersonasExcluir=${idPersona}`;
      });
      this.idsPersonasIncluir.forEach((idPersona) => {
        url += `&IdsPersonasIncluir=${idPersona}`;
      });
      this.idsMaquinasExcluir.forEach((idMaquinaIns) => {
        url += `&IdsMaquinasExcluir=${idMaquinaIns}`;
      });
      return url;
    },
  },
  methods: {
    initialize() {
      this.getTurnos();
      this.getPersonas();
      this.getMaquinaIns();
      this.getMoldes();
    },
    nombrePersona(persona) {
      if (!persona) return "";
      return [persona.nombre, persona.paterno, persona.materno].filter(Boolean).join(" ");
    },
    getIdOperador(personaLike) {
      const id = Number(
        personaLike && typeof personaLike === "object"
          ? (personaLike.idOperador != null
            ? personaLike.idOperador
            : personaLike.IdOperador != null
              ? personaLike.IdOperador
              : personaLike.idPersona != null
                ? personaLike.idPersona
                : personaLike.IdPersona)
          : personaLike
      );
      return Number.isFinite(id) && id > 0 ? id : null;
    },
    nombreMaquina(maquina) {
      return ` [${maquina.nombre}] - ${maquina.marca} ${maquina.modelo}`;
    },
    nombreMaquinaById(idMaquinaIns) {
      const maq = (this.maquinasIns || []).find((m) => String(m.idMaquinaIns) === String(idMaquinaIns));
      if (!maq) return "";
      return this.nombreMaquina(maq);
    },
    toStars(importancia) {
      const val = Number(importancia) || 0;
      return Math.max(0, Math.min(5, Math.round(val / 20)));
    },
    getTurnos() {
      axios
        .get("/Turnos")
        .then((response) => {
          this.turnos = response.data;
          if (this.turno == null && this.turnos.length > 0) {
            this.turno = this.turnos[0];
            this.getDatos();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getPersonas() {
      axios
        .get("/Personas/Operadores")
        .then((response) => {
          this.personas = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getMaquinaIns() {
      axios
        .get("/MaquinaInstancias")
        .then((response) => {
          this.maquinasIns = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getMoldes() {
      axios
        .get("/Moldes")
        .then((response) => {
          this.moldes = Array.isArray(response.data) ? response.data : [];
        })
        .catch((error) => {
          this.moldes = [];
          console.log(error);
        });
    },
    resetTurno() {
      this.turno = null;
      this.idsPersonasExcluir = [];
      this.idsPersonasIncluir = [];
      this.datos = [];
      this.dirtyImportancia = {};
      this.dirtyPersonas = {};
    },
    resetExcluir() {
      this.idsPersonasExcluir = [];
    },
    resetIncluir() {
      this.idsPersonasIncluir = [];
    },
    resetExcluirMaquinas() {
      this.idsMaquinasExcluir = [];
    },
    getDatos() {
      if (!this.realizarPeticion) return;
      this.loading = true;
      axios
        .get(this.urlDatos)
        .then((response) => {
          const rows = Array.isArray(response.data) ? response.data : [];
          this.datos = rows.map((item) => {
            const idsIniciales = this.getIdsOperadoresVinculados(item);
            const idMaquinaIns = this.getIdMaquinaIns(item);
            return {
              ...item,
              idFila: idMaquinaIns != null ? `maq-${idMaquinaIns}` : `tmp-${Math.random().toString(36).slice(2)}`,
              idsPersonasVinculadas: idsIniciales,
            };
          });
          this.dirtyImportancia = {};
          this.dirtyPersonas = {};
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    getIdsOperadoresVinculados(item) {
      if (!item || typeof item !== "object") return [];
      if (Array.isArray(item.idsOperadoresVinculados)) {
        return item.idsOperadoresVinculados
          .map((x) => Number(x))
          .filter((x) => Number.isFinite(x) && x > 0);
      }
      if (Array.isArray(item.idsPersonasVinculadas)) {
        return item.idsPersonasVinculadas
          .map((x) => Number(x))
          .filter((x) => Number.isFinite(x) && x > 0);
      }
      if (Array.isArray(item.personas)) {
        return item.personas
          .map((p) => this.getIdOperador(p))
          .filter((x) => Number.isFinite(x) && x > 0);
      }
      if (Array.isArray(item.Personas)) {
        return item.Personas
          .map((p) => this.getIdOperador(p))
          .filter((x) => Number.isFinite(x) && x > 0);
      }
      return [];
    },
    getIdMaquinaIns(item) {
      if (item && item.idMaquinaIns != null) return item.idMaquinaIns;
      if (item && item.IdMaquinaIns != null) return item.IdMaquinaIns;
      const nombre = String(item && item.nombre ? item.nombre : "").trim();
      const maq = (this.maquinasIns || []).find((m) => String(m.nombre || "").trim() === nombre);
      return maq ? maq.idMaquinaIns : null;
    },
    getIdMaquina(item) {
      if (item && item.idMaquina != null) return item.idMaquina;
      const idMaquinaIns = this.getIdMaquinaIns(item);
      const maqIns = (this.maquinasIns || []).find((m) => String(m.idMaquinaIns) === String(idMaquinaIns));
      return maqIns ? maqIns.idMaquina : null;
    },
    getMaquinaInsActual(item) {
      const idMaquinaIns = this.getIdMaquinaIns(item);
      if (idMaquinaIns == null) return null;
      return (this.maquinasIns || []).find((m) => String(m.idMaquinaIns) === String(idMaquinaIns)) || null;
    },
    toNumArray(items, key = null) {
      if (!Array.isArray(items)) return [];
      return items
        .map((item) => (key && item && typeof item === "object" ? item[key] : item))
        .map((item) => Number(item))
        .filter((item) => Number.isFinite(item) && item > 0);
    },
    getMoldeActual(item) {
      if (item && item.molde) return item.molde;
      if (item && item.Molde) return item.Molde;
      if (item && item.idMolde != null) {
        const byId = (this.moldes || []).find((m) => String(m.idMolde) === String(item.idMolde));
        if (byId) return byId;
      }
      if (item && item.idsMoldes && item.idsMoldes.length > 0) {
        const byId = (this.moldes || []).find((m) => String(m.idMolde) === String(item.idsMoldes[0]));
        if (byId) return byId;
      }
      if (item && item.IdsMoldes && item.IdsMoldes.length > 0) {
        const byId = (this.moldes || []).find((m) => String(m.idMolde) === String(item.IdsMoldes[0]));
        if (byId) return byId;
      }
      if (item && Array.isArray(item.moldes) && item.moldes.length > 0) return item.moldes[0];
      if (item && Array.isArray(item.Moldes) && item.Moldes.length > 0) return item.Moldes[0];
      const idMaquina = this.getIdMaquina(item);
      if (idMaquina == null) return null;
      return (this.moldes || []).find(
        (m) => String(m.idMaquina) === String(idMaquina) && Number(m.condicion || 1) === 1
      ) || null;
    },
    getIdMoldeActual(item) {
      const molde = this.getMoldeActual(item);
      if (!molde) return null;
      const idMolde = Number(molde.idMolde ?? molde.IdMolde);
      return Number.isFinite(idMolde) && idMolde > 0 ? idMolde : null;
    },
    idsHabilidadesMolde(item) {
      const molde = this.getMoldeActual(item);
      if (!molde) return [];
      const raw = Array.isArray(molde.habilidades)
        ? molde.habilidades
        : Array.isArray(molde.Habilidades)
          ? molde.Habilidades
          : Array.isArray(molde.IdsHabilidad)
            ? molde.IdsHabilidad
            : Array.isArray(molde.IdsHabilidades)
              ? molde.IdsHabilidades
          : Array.isArray(molde.idsHabilidad)
            ? molde.idsHabilidad
            : Array.isArray(molde.idsHabilidades)
              ? molde.idsHabilidades
              : [];
      return this.toNumArray(raw, "idHabilidad");
    },
    idsHabilidadesMaquina(item) {
      const maquinaIns = this.getMaquinaInsActual(item);
      if (!maquinaIns) return [];
      const raw = Array.isArray(maquinaIns.habilidades)
        ? maquinaIns.habilidades
        : Array.isArray(maquinaIns.Habilidades)
          ? maquinaIns.Habilidades
          : Array.isArray(maquinaIns.IdsHabilidad)
            ? maquinaIns.IdsHabilidad
            : Array.isArray(maquinaIns.IdsHabilidades)
              ? maquinaIns.IdsHabilidades
          : Array.isArray(maquinaIns.idsHabilidad)
            ? maquinaIns.idsHabilidad
            : Array.isArray(maquinaIns.idsHabilidades)
              ? maquinaIns.idsHabilidades
              : Array.isArray(maquinaIns.maquina?.habilidades)
                ? maquinaIns.maquina.habilidades
                : Array.isArray(maquinaIns.maquina?.Habilidades)
                  ? maquinaIns.maquina.Habilidades
                  : Array.isArray(maquinaIns.maquina?.IdsHabilidad)
                    ? maquinaIns.maquina.IdsHabilidad
                    : Array.isArray(maquinaIns.maquina?.IdsHabilidades)
                      ? maquinaIns.maquina.IdsHabilidades
                  : [];
      return this.toNumArray(raw, "idHabilidad");
    },
    idsHabilidadesRequeridas(item) {
      const deMolde = this.idsHabilidadesMolde(item);
      if (deMolde.length > 0) return deMolde;
      return this.idsHabilidadesMaquina(item);
    },
    idsHabilidadesPersona(idPersona) {
      const persona = this.personasById.get(Number(idPersona));
      if (!persona) return [];
      const raw = Array.isArray(persona.habilidades)
        ? persona.habilidades
        : Array.isArray(persona.Habilidades)
          ? persona.Habilidades
          : Array.isArray(persona.IdsHabilidad)
            ? persona.IdsHabilidad
            : Array.isArray(persona.idsHabilidad)
              ? persona.idsHabilidad
              : [];
      return this.toNumArray(raw, "idHabilidad");
    },
    personaCumpleMolde(item, idPersona) {
      const requeridas = this.idsHabilidadesRequeridas(item);
      if (requeridas.length === 0) return true;
      const personaSet = new Set(this.idsHabilidadesPersona(idPersona));
      return requeridas.every((idH) => personaSet.has(idH));
    },
    idsOcupadosEnOtrasFilas(itemActual) {
      const actualId = this.getIdMaquinaIns(itemActual);
      const ocupados = new Set();
      (this.datos || []).forEach((row) => {
        const rowId = this.getIdMaquinaIns(row);
        if (String(rowId) === String(actualId)) return;
        (row.idsPersonasVinculadas || []).forEach((id) => {
          const n = Number(id);
          if (Number.isFinite(n) && n > 0) ocupados.add(n);
        });
      });
      return ocupados;
    },
    personasDisponiblesPorItem(item) {
      const ocupados = this.idsOcupadosEnOtrasFilas(item);
      return (this.personasFiltradas || [])
        .map((p) => ({ ...p, idOperador: this.getIdOperador(p) }))
        .filter((p) => {
          const idOperador = Number(p && p.idOperador);
          if (!Number.isFinite(idOperador) || idOperador <= 0) return false;
          if (ocupados.has(idOperador)) return false;
          return this.personaCumpleMolde(item, idOperador);
        });
    },
    nombreMolde(molde) {
      if (!molde) return "Sin molde";
      const codigo = molde.codigo ? `[${molde.codigo}] ` : "";
      const nombre = molde.nombre || molde.tituloProducto || "Molde";
      return `${codigo}${nombre}`.trim();
    },
    nombreMoldeActual(item) {
      if (item && item.molde) return this.nombreMolde(item.molde);
      if (item && item.nombreMolde) return item.nombreMolde;
      const idMaquina = this.getIdMaquina(item);
      if (idMaquina == null) return "Sin molde";
      const molde = (this.moldes || []).find(
        (m) => String(m.idMaquina) === String(idMaquina) && Number(m.condicion || 1) === 1
      );
      return this.nombreMolde(molde);
    },
    actualizarImportancia(item, stars) {
      const nueva = Math.max(0, Math.min(100, Number(stars || 0) * 20));
      this.$set(item, "importanciaMaquina", nueva);
      const idMaquinaIns = this.getIdMaquinaIns(item);
      if (idMaquinaIns == null) return;
      this.$set(this.dirtyImportancia, String(idMaquinaIns), nueva);
    },
    marcarCambioPersonas(item) {
      const idMaquinaIns = this.getIdMaquinaIns(item);
      if (idMaquinaIns == null) return;
      const idsRaw = Array.isArray(item.idsPersonasVinculadas)
        ? item.idsPersonasVinculadas.map((x) => Number(x)).filter((x) => Number.isFinite(x) && x > 0)
        : [];
      const ocupados = this.idsOcupadosEnOtrasFilas(item);
      const ids = idsRaw
        .filter((id) => !ocupados.has(id))
        .filter((id) => this.personaCumpleMolde(item, id));
      if (ids.length !== idsRaw.length) {
        this.$set(item, "idsPersonasVinculadas", ids);
      }
      this.$set(this.dirtyPersonas, String(idMaquinaIns), ids);
    },
    async guardarCambios() {
      if (!this.tieneCambios) return;
      this.saving = true;
      try {
        const importancias = Object.keys(this.dirtyImportancia).map((idMaquinaIns) => ({
          idMaquinaIns: Number(idMaquinaIns),
          importancia: Number(this.dirtyImportancia[idMaquinaIns]) || 0,
        }));
        const asignaciones = Object.keys(this.dirtyPersonas).map((idMaquinaIns) => ({
          idMaquinaIns: Number(idMaquinaIns),
          idMolde: this.getIdMoldeActual(
            (this.datos || []).find((x) => String(this.getIdMaquinaIns(x)) === String(idMaquinaIns)) || null
          ),
          idsOperadores: this.dirtyPersonas[idMaquinaIns] || [],
          idsPersonas: this.dirtyPersonas[idMaquinaIns] || [],
        }));

        if (importancias.length > 0) {
          await axios.put(EP_GUARDAR_IMPORTANCIA, { maquinas: importancias });
        }
        if (asignaciones.length > 0) {
          await axios.put(EP_GUARDAR_VINCULOS, { maquinas: asignaciones });
        }

        this.dirtyImportancia = {};
        this.dirtyPersonas = {};
        await this.getDatos();
      } catch (error) {
        console.log(error);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
